import React, { useCallback, useEffect, useState } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import FormDatePicker from "../../../components/formFields/FormDateField";
import moment from "moment";
import { Typography } from "@progress/kendo-react-common";
import ShadowCard from "../../../components/common/ShadowCard";
import { getAllItemIncremental } from "../../Item/services/item.services";
import {
  clearCreditNoteRegisterDetails,
  clearCreditNoteRegisterList,
  setCreditNoteRegisterReport,
} from "../reportsSlice";
import AlertBox from "../../../components/common/AlertBox";
import { LoadingPanel } from "../../../components/layout/Loading";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import FormIncrementalSearch from "../../../components/formFields/FormIncrementalSearch";
import { clearItemList } from "../../Item/itemSlice";
import { Button } from "@progress/kendo-react-buttons";
import Logo from "../../../assets/Images/logo.png";
import {
  checkAcessRights,
  formatIndianNumber,
  formatIndianNumberForQty,
} from "../../../_helper/helper";
import {
  EDIT_ACCESS,
  // EXCEL_EXPORT_ACCESS,
  // PRINT_ACCESS,
} from "../../../_contstants/common";
import { getAllAccountIncremental } from "../../account/services/account.services";
import { RxCross2 } from "react-icons/rx";
import FormCheckboxGroup from "../../../components/formFields/FormCheckboxGroup";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { BsThreeDotsVertical } from "react-icons/bs";
import { getCreditNoteRegisterReport } from "../services/reports.services";
import { FiEdit } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import IconButton from "../../../components/common/IconButton";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const DummyChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const createdBy = localStorage.getItem("UserID");
  useEffect(() => {
    formRenderProps.onChange("UserID", {
      value: createdBy,
    });
  }, []);

  return null;
};

const CreditNoteRegisterReportForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.reports.loading);
  const CreditNoteRegisterList = useAppSelector(
    (state) => state.reports.CreditNoteRegisterList
  );
  const CreditNoteRegisterDetails = useAppSelector(
    (state) => state.reports.CreditNoteRegisterDetails
  );
  const [initialValue, setInitialValue] = useState<any>({});
  const [formKey, setFormKey] = useState<any>(1);

  useEffect(() => {
    setInitialValue({
      ...CreditNoteRegisterDetails,
      from_date: CreditNoteRegisterDetails?.from_date
        ? moment(CreditNoteRegisterDetails?.from_date, "YYYY-MM-DD").toDate()
        : null,
      to_date: CreditNoteRegisterDetails?.to_date
        ? moment(CreditNoteRegisterDetails?.to_date, "YYYY-MM-DD").toDate()
        : null,
    });
    setFormKey(formKey + 1);
  }, [CreditNoteRegisterDetails]);

  const handleVendorSearchChange = useCallback(
    async (search: string, field: string, formRenderProps: FormRenderProps) => {
      const result = await dispatch(getAllAccountIncremental(search));
      formRenderProps.onChange(field, {
        value: result.payload,
      });
    },
    [dispatch]
  );

  const handleItemSearchChange = useCallback(
    async (search: string, field: string, formRenderProps: FormRenderProps) => {
      const result = await dispatch(getAllItemIncremental({ search }));
      formRenderProps.onChange(field, {
        value: result.payload,
      });
    },
    [dispatch]
  );

  const handleSubmit = (values: any) => {
    const payload = {
      item_id: values?.item_id ? values?.item_id : null,
      vendor_id: values?.vendor_id ? values?.vendor_id : null,
      from_date: values?.from_date
        ? moment(values?.from_date).format("YYYY-MM-DD")
        : null,
      to_date: values?.to_date
        ? moment(values?.to_date).format("YYYY-MM-DD")
        : null,
    };
    const setPayload = {
      ...payload,
      vendor_options: values?.vendor_options || [],
      item_options: values?.item_options || [],
      isCreditNoteRef: true,
    };
    dispatch(setCreditNoteRegisterReport(setPayload));
    dispatch(getCreditNoteRegisterReport(payload));
  };

  return (
    <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
      <GridLayoutItem>
        <ShadowCard>
          <Form
            key={formKey}
            initialValues={initialValue}
            onSubmit={handleSubmit}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  style={{ marginRight: 30 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                  ]}
                >
                  <GridLayoutItem colSpan={4}>
                    <Typography.h4
                      style={{ marginBottom: 0, marginLeft: "3px" }}
                    >
                      Sales Return Register
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="from_date"
                      label="From Date"
                      format="dd/MM/yyyy"
                      component={FormDatePicker}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="to_date"
                      label="To Date"
                      format="dd/MM/yyyy"
                      minDate={
                        moment(
                          formRenderProps.valueGetter("from_date")
                        ).toDate() || new Date(1900, 0, 1)
                      }
                      component={FormDatePicker}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="vendor_id"
                      label="Vendor"
                      placeholder="Type here to search Vendor..."
                      component={FormIncrementalSearch}
                      fetchIncrementalData={(search: any) =>
                        handleVendorSearchChange(
                          search,
                          `vendor_options`,
                          formRenderProps
                        )
                      }
                      options={
                        formRenderProps
                          .valueGetter("vendor_options")
                          ?.map((item: any) => {
                            return {
                              value: item.id,
                              label: item.account_name,
                            };
                          }) || []
                      }
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="w-100"
                      name="item_id"
                      label="Product Name"
                      placeholder="Type here to search item..."
                      component={FormIncrementalSearch}
                      fetchIncrementalData={(search: any) =>
                        handleItemSearchChange(
                          search,
                          `item_options`,
                          formRenderProps
                        )
                      }
                      options={
                        formRenderProps
                          .valueGetter("item_options")
                          ?.map((item: any) => {
                            return {
                              value: item?.id,
                              label: item?.product_name,
                            };
                          }) || []
                      }
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    colSpan={4}
                    style={{
                      textAlign: "end",
                      marginTop: 10,
                    }}
                  >
                    <ButtonWithLoading
                      label={"View"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || loading}
                      loading={loading}
                    />
                  </GridLayoutItem>
                </GridLayout>
                <DummyChangeWatcher formRenderProps={formRenderProps} />
              </FormElement>
            )}
          />
        </ShadowCard>
        {/* {loading ? (
          <LoadingPanel gridRef={gridRef} />
        ) : ( */}
        {CreditNoteRegisterList && CreditNoteRegisterList.length > 0 && (
          <ShadowCard style={{ marginTop: 10 }}>
            <CreditNoteRegisterGridCommponent />
          </ShadowCard>
        )}
        {/* )} */}
      </GridLayoutItem>
    </GridLayout>
  );
};

const columns = [
  // { label: "Sales Return No.", value: "credit_note_no_string" },
  { label: "Sales Return Date", value: "credit_note_date" },
  { label: "Bill No.", value: "bill_no" },
  { label: "Bill Date", value: "bill_date" },
  { label: "Vendor Name", value: "account_name" },
  { label: "Total Amount", value: "total_amount" },
  // { label: "GST", value: "gst" },
  // { label: "CGST", value: "cgst" },
  // { label: "SGST", value: "sgst" },
  // { label: "IGST", value: "igst" },
  { label: "Item Name", value: "product_name" },
  { label: "Quantity", value: "quantity" },
  { label: "Unit Name", value: "unit_name" },
  { label: "Rate", value: "rate" },
  { label: "Free Quantity", value: "free_quantity" },
  { label: "Discount", value: "discount" },
  { label: "SGST (%)", value: "sgst_per" },
  { label: "SGST Amount", value: "sgst_amount" },
  { label: "CGST (%)", value: "cgst_per" },
  { label: "CGST Amount", value: "cgst_amount" },
  { label: "IGST (%)", value: "igst_per" },
  { label: "IGST Amount", value: "igst_amount" },

  { label: "Online Sales", value: "online_sales" },

  {
    label: "GST Sales Nill Rate Amount",
    value: "gst_sales_nill_rate_taxable_amount",
  },
  {
    label: "IGST Sales Nill Rate Amount",
    value: "i_gst_sales_nill_rate_taxable_amount",
  },
  { label: "Sales GST 5%", value: "gst_sales_5_taxable_amount" },
  { label: "CGST 2.5%", value: "cgst_2_5_taxable_amount" },
  { label: "SGST 2.5%", value: "sgst_2_5_taxable_amount" },
  { label: "Sales IGST 5%", value: "i_gst_sales_5_taxable_amount" },
  { label: "IGST 5%", value: "igst_5_taxable_amount" },

  { label: "Sales GST 12%", value: "gst_sales_12_taxable_amount" },
  { label: "CGST 6%", value: "cgst_6_taxable_amount" },
  { label: "SGST 6%", value: "sgst_6_taxable_amount" },
  { label: "Sales IGST 12%", value: "i_gst_sales_12_taxable_amount" },
  { label: "IGST 12%", value: "igst_12_taxable_amount" },

  { label: "Sales GST 18%", value: "gst_sales_18_taxable_amount" },
  { label: "CGST 9%", value: "cgst_9_taxable_amount" },
  { label: "SGST 9%", value: "sgst_9_taxable_amount" },
  { label: "Sales IGST 18%", value: "i_gst_sales_18_taxable_amount" },
  { label: "IGST 18%", value: "igst_18_taxable_amount" },

  { label: "Sales GST 28%", value: "gst_sales_28_taxable_amount" },
  { label: "CGST 14%", value: "cgst_14_taxable_amount" },
  { label: "SGST 14%", value: "sgst_14_taxable_amount" },
  { label: "Sales IGST 28%", value: "i_gst_sales_28_taxable_amount" },
  { label: "IGST 28%", value: "igst_28_taxable_amount" },
  { label: "CESS 12%", value: "cess_12_taxable_amount" },

  { label: "Sales GST Return", value: "gst_sales_returns" },

  { label: "purchase_5_taxable_amount", value: "purchase_5_taxable_amount" },
  { label: "Vatav", value: "vatav" },
  { label: "Fright", value: "fright_inward" },
  { label: "Dalali", value: "dalali" },
  { label: "Kharajat", value: "kharajat" },
];
const CreditNoteRegisterGridCommponent: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  // const location = useLocation();
  const gridRef = React.useRef<any>(null);
  const isEditBtnRef = React.useRef<any>(false);
  const isEditAccess = checkAcessRights("/creditnote", EDIT_ACCESS);
  // const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);
  // const isExcelAccess = checkAcessRights(
  //   location.pathname,
  //   EXCEL_EXPORT_ACCESS
  // );

  const loading = useAppSelector((state) => state.reports.loading);
  const CreditNoteRegisterList = useAppSelector(
    (state) => state.reports.CreditNoteRegisterList
  );
  const CreditNoteRegisterDetails = useAppSelector(
    (state) => state.reports.CreditNoteRegisterDetails
  );
  const [showfilterColumns, setShowFilterColumns] = React.useState(false);
  const [selectedGroup, setSelectedGroup] = React.useState<string | null>(null);

  useEffect(() => {
    return () => {
      if (!isEditBtnRef.current) {
        dispatch(clearCreditNoteRegisterList());
        dispatch(clearCreditNoteRegisterDetails());
        dispatch(clearItemList());
      }
    };
  }, []);

  const handleExportExcel = () => {
    const table = document.querySelector(
      ".currentstock-print-table"
    ) as HTMLTableElement;
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(table);

    // Adjust column widths dynamically
    const colWidths: number[] = [];
    const rows = table.querySelectorAll("tr");

    rows.forEach((row) => {
      const cells = row.querySelectorAll("th, td");
      cells.forEach((cell, colIndex) => {
        const cellContent = cell.textContent || "";
        const cellLength = cellContent.length;

        // Calculate width (max of existing or current cell)
        colWidths[colIndex] = Math.max(
          colWidths[colIndex] || 10,
          cellLength + 2
        );
      });
    });
    // Apply column widths
    ws["!cols"] = colWidths.map((width) => ({ wch: width }));

    Object.keys(ws).forEach((key) => {
      if (!key.startsWith("!")) {
        const cell = ws[key];
        if (cell.z !== "m/d/yy") {
          if (typeof cell.v === "number") {
            // Check if the cell is a date (custom logic depending on your use case)
            const isDate = cell.t === "d"; // 't' might indicate the cell type in some libraries
            if (!isDate) {
              cell.t = "s"; // Set cell type to 'string'
              cell.v = `${cell.v}`; // Convert number to string
            }
          }
        } else if (cell.z === "m/d/yy") {
          cell.z = "DD-MMM-YYYY";
        }
      }
    });

    XLSX.utils.book_append_sheet(wb, ws, `Sheet 1`);

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, `Sales Return Register Report`);
  };

  const handleRowClick = (credit_note_guid: string) => {
    const groupKey = `${credit_note_guid}`;
    setSelectedGroup(selectedGroup === groupKey ? null : groupKey);
  };

  const initialValues = {
    filter_columns: [
      // "credit_note_no_string",
      "credit_note_date",
      "bill_no",
      "bill_date",
      "account_name",
      "total_amount",
      // "gst",
      // "cgst",
      // "sgst",
      // "igst",
      // "product_name",
      // "quantity",
      // "unit_name",
      // "rate",
      // "free_quantity",
      // "discount",
      // "sgst_per",
      // "sgst_amount",
      // "cgst_per",
      // "cgst_amount",
      // "igst_per",
      // "igst_amount",

      "online_sales",
      "gst_sales_5_taxable_amount",
      "cgst_2_5_taxable_amount",
      "sgst_2_5_taxable_amount",
      "i_gst_sales_5_taxable_amount",
      "igst_5_taxable_amount",
      "gst_sales_12_taxable_amount",
      "cgst_6_taxable_amount",
      "sgst_6_taxable_amount",
      "i_gst_sales_12_taxable_amount",
      "igst_12_taxable_amount",
      "gst_sales_18_taxable_amount",
      "cgst_9_taxable_amount",
      "sgst_9_taxable_amount",
      "i_gst_sales_18_taxable_amount",
      "igst_18_taxable_amount",
      "gst_sales_28_taxable_amount",
      "cgst_14_taxable_amount",
      "sgst_14_taxable_amount",
      "i_gst_sales_28_taxable_amount",
      "igst_28_taxable_amount",
      "cess_12_taxable_amount",
      "gst_sales_returns",
      "purchase_5_taxable_amount",
      "gst_sales_nill_rate_taxable_amount",
      "i_gst_sales_nill_rate_taxable_amount",
      // "vatav",
      // "fright_inward",
      // "dalali",
      // "kharajat",
      // "amount",
    ],
  };

  // type DataItem = { [key: string]: number | null };

  // const calculateTotals = (
  //   data: DataItem[],
  //   keysToTotal: string[]
  // ): { [key: string]: number } => {
  //   const totals: { [key: string]: number } = {};
  //   keysToTotal.forEach((key) => {
  //     totals[key] = data.reduce((sum, item) => sum + (item[key] || 0), 0);
  //   });

  //   return totals;
  // };

  const GrandTotalArray: any = [
    "quantity",
    "free_quantity",
    "cgst_amount",
    "sgst_amount",
    "igst_amount",
    "gst",
    "cgst",
    "sgst",
    "igst",
    "total_amount",
  ];

  const groupedData = CreditNoteRegisterList.reduce((acc: any, item: any) => {
    const { credit_note_guid } = item;
    acc[credit_note_guid] = acc[credit_note_guid] || [];
    acc[credit_note_guid].push(item);
    return acc;
  }, {});
  const groupedArray = Object.values(groupedData);
  let totalQty = 0;
  let totalFreeQty = 0;

  let totalCGSTAmount = 0;
  let totalSGSTAmount = 0;
  let totalIGSTAmount = 0;
  // let GrandtotalCGSTAmount = 0;
  // let GrandtotalSGSTAmount = 0;
  // let GrandtotalIGSTAmount = 0;

  // let GrandtotalGSTAmount = 0;
  let GrandTotalAmount = 0;

  let totalGrandOnlineSalesAmount = 0;
  let totalGrandGSTSalesTaxableAmount = 0;
  let totalGrandIGSTSalesTaxableAmount = 0;

  let totalGrandSalesGST5Amount = 0;
  let totalGrandCGST2_5Amount = 0;
  let totalGrandSGST2_5Amount = 0;
  let totalGrandSalesIGST5Amount = 0;
  let totalGrandIGST5Amount = 0;
  let totalGrandSalesGST12Amount = 0;
  let totalGrandCGST6Amount = 0;
  let totalGrandSGST6Amount = 0;
  let totalGrandSalesIGST12Amount = 0;
  let totalGrandIGST12Amount = 0;
  let totalGrandSalesGST18Amount = 0;
  let totalGrandCGST9Amount = 0;
  let totalGrandSGST9Amount = 0;
  let totalGrandSalesIGST18Amount = 0;
  let totalGrandIGST18Amount = 0;
  let totalGrandSalesGST28Amount = 0;
  let totalGrandCGST14Amount = 0;
  let totalGrandSGST14Amount = 0;
  let totalGrandSalesIGST28Amount = 0;
  let totalGrandIGST28Amount = 0;
  let totalGrandCESS12Amount = 0;

  let totalGrandGSTSalesReturnAmount = 0;
  let totalGrandVatavAmount = 0;
  let totalGrandFrightAmount = 0;
  let totalGrandDalaliAmount = 0;
  let totalGrandKharajatAmount = 0;

  groupedArray &&
    groupedArray.length > 0 &&
    groupedArray?.map((group: any) => {
      group?.map((item: any, index: number) => {
        totalQty += item?.quantity || 0;
        totalFreeQty += item?.free_quantity || 0;

        totalCGSTAmount += item?.cgst_amount || 0;
        totalSGSTAmount += item?.sgst_amount || 0;
        totalIGSTAmount += item?.igst_amount || 0;

        if (index === 0) {
          // GrandtotalCGSTAmount += item.cgst || 0;
          // GrandtotalSGSTAmount += item.sgst || 0;
          // GrandtotalIGSTAmount += item.igst || 0;
          // GrandtotalGSTAmount += item.gst || 0;

          GrandTotalAmount += item.total_amount || 0;
          totalGrandOnlineSalesAmount += item.online_sales || 0;
          totalGrandGSTSalesTaxableAmount +=
            item.gst_sales_nill_rate_taxable_amount || 0;
          totalGrandIGSTSalesTaxableAmount +=
            item.i_gst_sales_nill_rate_taxable_amount || 0;
          totalGrandSalesGST5Amount += item.gst_sales_5_taxable_amount || 0;
          totalGrandCGST2_5Amount += item.cgst_2_5_taxable_amount || 0;
          totalGrandSGST2_5Amount += item.sgst_2_5_taxable_amount || 0;
          totalGrandSalesIGST5Amount += item.i_gst_sales_5_taxable_amount || 0;
          totalGrandIGST5Amount += item.igst_5_taxable_amount || 0;
          totalGrandSalesGST12Amount += item.gst_sales_12_taxable_amount || 0;
          totalGrandCGST6Amount += item.cgst_6_taxable_amount || 0;
          totalGrandSGST6Amount += item.sgst_6_taxable_amount || 0;
          totalGrandSalesIGST12Amount +=
            item.i_gst_sales_12_taxable_amount || 0;
          totalGrandIGST12Amount += item.igst_12_taxable_amount || 0;
          totalGrandSalesGST18Amount += item.gst_sales_18_taxable_amount || 0;
          totalGrandCGST9Amount += item.cgst_9_taxable_amount || 0;
          totalGrandSGST9Amount += item.sgst_9_taxable_amount || 0;
          totalGrandSalesIGST18Amount +=
            item.i_gst_sales_18_taxable_amount || 0;
          totalGrandIGST18Amount += item.igst_18_taxable_amount || 0;
          totalGrandSalesGST28Amount += item.gst_sales_28_taxable_amount || 0;
          totalGrandCGST14Amount += item.cgst_14_taxable_amount || 0;
          totalGrandSGST14Amount += item.sgst_14_taxable_amount || 0;
          totalGrandSalesIGST28Amount +=
            item.i_gst_sales_28_taxable_amount || 0;
          totalGrandIGST28Amount += item.igst_28_taxable_amount || 0;
          totalGrandCESS12Amount += item.cess_12_taxable_amount || 0;
          totalGrandGSTSalesReturnAmount += item.gst_sales_returns || 0;
          totalGrandVatavAmount += item.vatav || 0;
          totalGrandFrightAmount += item.fright_inward || 0;
          totalGrandDalaliAmount += item.dalali || 0;
          totalGrandKharajatAmount += item.kharajat || 0;
        }
      });
    });

  const printTable = (data: any[], formRenderProps: any) => {
    let printbuttons = document.querySelector(
      ".printbuttons"
    ) as HTMLElement | null;
    let report_container = document.querySelector(
      ".report-container"
    ) as HTMLElement | null;

    if (printbuttons) printbuttons.style.display = "none";
    if (report_container) report_container.style.padding = "20px 0";

    let tableRows = data.length;
    let maxRows = tableRows;
    let pageCount = Math.ceil(tableRows / maxRows);
    let content = "";

    for (let i = 0; i < pageCount; i++) {
      content += '<div class="print-page">';
      content +=
        '<table class="table table-bordered" style="font-size:10px;margin-bottom:30px;">';
      content += "<tr>";
      content += `<td rowSpan="3" style="width:15%" ><img src="${Logo}" width="100%" /></td>`;
      content +=
        '<td colSpan="2" style="text-align: center;font-size: 14px;font-weight: 600;color: gray;">Harihar Foods Pvt Ltd.</td>';
      content += "</tr>";
      content += "<tr>";
      content +=
        '<td colSpan="2"><h3 style="margin:0;">Sales Return Register Report</h3></td>';
      content += "</tr>";
      content += "<tr>";
      content += `<td style="text-align:end;">Page : ${i + 1}</td>`;
      content += "</tr>";

      content += "</table>";

      content += '<table class="table table-bordered" style="font-size:10px;">';
      content += '<thead style="background:lightgray;">';
      content += "<tr>";
      content += '<th style="width:30px;">Sales Return No.</th>';
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("credit_note_date") &&
          (content += '<th style="width:30px;">Sales Return Date.</th>');
      }
      {
        formRenderProps.valueGetter("filter_columns")?.includes("bill_no") &&
          (content += "<th>Bill No</th>");
      }
      {
        formRenderProps.valueGetter("filter_columns")?.includes("bill_date") &&
          (content += "<th>Bill Date</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("account_name") && (content += "<th>Vendor Name</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("product_name") && (content += "<th>Product Name</th>");
      }
      {
        formRenderProps.valueGetter("filter_columns")?.includes("quantity") &&
          (content += "<th>Quantity</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("free_quantity") && (content += "<th>Free Quantity</th>");
      }
      {
        formRenderProps.valueGetter("filter_columns")?.includes("rate") &&
          (content += "<th>Rate</th>");
      }
      {
        formRenderProps.valueGetter("filter_columns")?.includes("unit_name") &&
          (content += "<th>Unit Name</th>");
      }
      {
        formRenderProps.valueGetter("filter_columns")?.includes("discount") &&
          (content += "<th>Discount</th>");
      }
      {
        formRenderProps.valueGetter("filter_columns")?.includes("cgst_per") &&
          (content += "<th>CGST(%) </th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("cgst_amount") && (content += "<th>CGST Amount</th>");
      }
      {
        formRenderProps.valueGetter("filter_columns")?.includes("sgst_per") &&
          (content += "<th>SGST(%)</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("sgst_amount") && (content += "<th>SGST Amount</th>");
      }
      {
        formRenderProps.valueGetter("filter_columns")?.includes("igst_per") &&
          (content += "<th>IGST(%)</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("igst_amount") && (content += "<th>IGST Amount</th>");
      }

      // {
      //   formRenderProps.valueGetter("filter_columns")?.includes("cgst") &&
      //     (content += "<th>Total CGST</th>");
      // }
      // {
      //   formRenderProps.valueGetter("filter_columns")?.includes("sgst") &&
      //     (content += "<th>Total SGST</th>");
      // }
      // {
      //   formRenderProps.valueGetter("filter_columns")?.includes("igst") &&
      //     (content += "<th>Total IGST</th>");
      // }
      // {
      //   formRenderProps.valueGetter("filter_columns")?.includes("gst") &&
      //     (content += "<th>Total GST </th>");
      // }

      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("online_sales") && (content += "<th>Online Sales</th>");
      }

      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("gst_sales_5_taxable_amount") &&
          (content += "<th>Sales GST 5%</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("cgst_2_5_taxable_amount") &&
          (content += "<th>CGST 2.5%</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("sgst_2_5_taxable_amount") &&
          (content += "<th>SGST 2.5%</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("i_gst_sales_5_taxable_amount") &&
          (content += "<th>Sales IGST 5%</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("igst_5_taxable_amount") &&
          (content += "<th>IGST 5%</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("gst_sales_12_taxable_amount") &&
          (content += "<th>Sales GST 12%</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("cgst_6_taxable_amount") &&
          (content += "<th>CGST 6%</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("sgst_6_taxable_amount") &&
          (content += "<th>SGST 6%</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("i_gst_sales_12_taxable_amount") &&
          (content += "<th>Sales IGST 12%</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("igst_12_taxable_amount") &&
          (content += "<th>IGST 12%</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("gst_sales_18_taxable_amount") &&
          (content += "<th>Sales GST 18%</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("cgst_9_taxable_amount") &&
          (content += "<th>CGST 9%</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("sgst_9_taxable_amount") &&
          (content += "<th>SGST 9%</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("i_gst_sales_18_taxable_amount") &&
          (content += "<th>Sales IGST 18%</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("igst_18_taxable_amount") &&
          (content += "<th>IGST 18%</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("gst_sales_28_taxable_amount") &&
          (content += "<th>Sales GST 28%</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("cgst_14_taxable_amount") &&
          (content += "<th>CGST 14%</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("sgst_14_taxable_amount") &&
          (content += "<th>SGST 14%</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("i_gst_sales_28_taxable_amount") &&
          (content += "<th>Sales IGST 28%</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("igst_28_taxable_amount") &&
          (content += "<th>ISGT 28%</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("cess_12_taxable_amount") &&
          (content += "<th>CESS 12%</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("gst_sales_returns") &&
          (content += "<th>GST Sales Return</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("gst_sales_nill_rate_taxable_amount") &&
          (content += "<th>GST Sales Nill Rate Amount</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("i_gst_sales_nill_rate_taxable_amount") &&
          (content += "<th>IGST Sales Nill Rate Amount</th>");
      }
      {
        formRenderProps.valueGetter("filter_columns")?.includes("vatav") &&
          (content += "<th>Vatav</th>");
      }
      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("fright_inward") && (content += "<th>Fright</th>");
      }
      {
        formRenderProps.valueGetter("filter_columns")?.includes("dalali") &&
          (content += "<th>Dalali</th>");
      }
      {
        formRenderProps.valueGetter("filter_columns")?.includes("kharajat") &&
          (content += "<th>Kharajat</th>");
      }

      {
        formRenderProps
          .valueGetter("filter_columns")
          ?.includes("total_amount") && (content += "<th>Total Amount</th>");
      }
      content += "</tr>";
      content += "</thead>";
      content += "<tbody>";

      // let startRow = i * maxRows;
      // let endRow = Math.min((i + 1) * maxRows, tableRows);

      data.map((group: any) =>
        group.map((item: any, index: any) => {
          content += "<tr className='debitnote-avoid-break'>";
          index === 0 &&
            (content += `<td rowspan="${group.length}" >${
              item.credit_note_no_string ? item.credit_note_no_string : ""
            }</td>`);
          // {
          //   formRenderProps
          //     .valueGetter("filter_columns")
          //     ?.includes("credit_note_date") &&
          //     index === 0 &&
          //     (content += `<td rowspan="${group.length}" class="text-start">${item.credit_note_date}</td>`);
          // }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("credit_note_date") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:center;">${
                item?.credit_note_date
                  ? moment(item?.credit_note_date, "DD/MM/YYYY").format(
                      "DD MMM YYYY"
                    )
                  : ""
              }</td>`);
          }
          // {
          //   formRenderProps
          //     .valueGetter("filter_columns")
          //     ?.includes("bill_no") &&
          //     index === 0 &&
          //     (content += `<td rowspan="${
          //       group.length
          //     }" style="text-align:center;">${
          //       item.inward_no ? item.inward_no : ""
          //     }</td>`);
          // }

          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("bill_no") &&
              index === 0 &&
              (content += `<td rowspan="${group.length}" class="text-start">${item.bill_no}</td>`);
          }

          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("bill_date") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:center;">${
                item?.bill_date
                // ? moment(item?.bill_date, "DD/MM/YYYY").format("")
                // : ""
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("account_name") &&
              index === 0 &&
              (content += `<td rowspan="${group.length}" style="text-align:center;">${item.account_name}</td>`);
          }

          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("product_name") &&
              index === 0 &&
              (content += `<td rowspan="${group.length}" style="text-align:center;">${item.product_name}</td>`);
          }

          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("quantity") &&
              (content += `<td style="text-align:end;">${
                item.quantity ? formatIndianNumberForQty(item.quantity) : 0
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("free_quantity") &&
              (content += `<td style="text-align:end;">${
                item.free_quantity
                  ? formatIndianNumberForQty(item.free_quantity)
                  : 0
              }</td>`);
          }

          {
            formRenderProps.valueGetter("filter_columns")?.includes("rate") &&
              index === 0 &&
              (content += `<td rowspan="${group.length}" style="text-align:center;">${item.rate}</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("unit_name") &&
              index === 0 &&
              (content += `<td rowspan="${group.length}" style="text-align:center;">${item.unit_name}</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("discount") &&
              (content += `<td style="text-align:end;">${
                item.discount ? item.discount : ""
              } ${
                item.discount && item.discount_type
                  ? item.discount_type === 1
                    ? "₹"
                    : item.discount_type === 2
                    ? "%"
                    : ""
                  : ""
              }</td>`);
          }

          // cgst_per;
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("cgst_per") &&
              (content += `<td style="text-align:end;">${
                item.cgst_per ? `${item.cgst_per} %` : ""
              }</td>`);
          }

          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("cgst_amount") &&
              (content += `<td style="text-align:end;">${
                item.cgst_amount ? formatIndianNumber(item.cgst_amount) : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("sgst_per") &&
              (content += `<td style="text-align:end;">${
                item.sgst_per ? `${item.sgst_per} %` : ""
              }</td>`);
          }

          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("sgst_amount") &&
              (content += `<td style="text-align:end;">${
                item.sgst_amount ? formatIndianNumber(item.sgst_amount) : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("igst_per") &&
              (content += `<td style="text-align:end;">${
                item.igst_per ? `${item.igst_per} %` : ""
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("igst_amount") &&
              (content += `<td style="text-align:end;">${
                item.igst_amount ? formatIndianNumber(item.igst_amount) : "0.00"
              }</td>`);
          }

          // {
          //   formRenderProps.valueGetter("filter_columns")?.includes("cgst") &&
          //     index === 0 &&
          //     (content += `<td rowspan="${
          //       group.length
          //     }" style="text-align:end;">${
          //       item.cgst ? formatIndianNumber(item.cgst) : "0.00"
          //     }</td>`);
          // }
          // {
          //   formRenderProps.valueGetter("filter_columns")?.includes("sgst") &&
          //     index === 0 &&
          //     (content += `<td rowspan="${
          //       group.length
          //     }" style="text-align:end;">${
          //       item.sgst ? formatIndianNumber(item.sgst) : "0.00"
          //     }</td>`);
          // }
          // {
          //   formRenderProps.valueGetter("filter_columns")?.includes("igst") &&
          //     index === 0 &&
          //     (content += `<td rowspan="${
          //       group.length
          //     }" style="text-align:end;">${
          //       item.igst ? formatIndianNumber(item.igst) : "0.00"
          //     }</td>`);
          // }

          // {
          //   formRenderProps.valueGetter("filter_columns")?.includes("gst") &&
          //     index === 0 &&
          //     (content += `<td rowspan="${
          //       group.length
          //     }" style="text-align:end;">${
          //       item.gst ? formatIndianNumber(item.gst) : "0.00"
          //     }</td>`);
          // }

          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("online_sales") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.online_sales
                  ? formatIndianNumber(item.online_sales)
                  : "0.00"
              }</td>`);
          }

          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("gst_sales_5_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.gst_sales_5_taxable_amount
                  ? formatIndianNumber(item.gst_sales_5_taxable_amount)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("cgst_2_5_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.cgst_2_5_taxable_amount
                  ? formatIndianNumber(item.cgst_2_5_taxable_amount)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("sgst_2_5_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.sgst_2_5_taxable_amount
                  ? formatIndianNumber(item.sgst_2_5_taxable_amount)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("i_gst_sales_5_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.i_gst_sales_5_taxable_amount
                  ? formatIndianNumber(item.i_gst_sales_5_taxable_amount)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("igst_5_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.igst_5_taxable_amount
                  ? formatIndianNumber(item.igst_5_taxable_amount)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("gst_sales_12_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.gst_sales_12_taxable_amount
                  ? formatIndianNumber(item.gst_sales_12_taxable_amount)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("cgst_6_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.cgst_6_taxable_amount
                  ? formatIndianNumber(item.cgst_6_taxable_amount)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("sgst_6_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.sgst_6_taxable_amount
                  ? formatIndianNumber(item.sgst_6_taxable_amount)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("i_gst_sales_12_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.i_gst_sales_12_taxable_amount
                  ? formatIndianNumber(item.i_gst_sales_12_taxable_amount)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("igst_12_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.igst_12_taxable_amount
                  ? formatIndianNumber(item.igst_12_taxable_amount)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("gst_sales_18_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.gst_sales_18_taxable_amount
                  ? formatIndianNumber(item.gst_sales_18_taxable_amount)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("cgst_9_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.cgst_9_taxable_amount
                  ? formatIndianNumber(item.cgst_9_taxable_amount)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("sgst_9_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.sgst_9_taxable_amount
                  ? formatIndianNumber(item.sgst_9_taxable_amount)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("i_gst_sales_18_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.i_gst_sales_18_taxable_amount
                  ? formatIndianNumber(item.i_gst_sales_18_taxable_amount)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("igst_18_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.igst_18_taxable_amount
                  ? formatIndianNumber(item.igst_18_taxable_amount)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("gst_sales_28_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.gst_sales_28_taxable_amount
                  ? formatIndianNumber(item.gst_sales_28_taxable_amount)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("cgst_14_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.cgst_14_taxable_amount
                  ? formatIndianNumber(item.cgst_14_taxable_amount)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("sgst_14_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.sgst_14_taxable_amount
                  ? formatIndianNumber(item.sgst_14_taxable_amount)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("i_gst_sales_28_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.i_gst_sales_28_taxable_amount
                  ? formatIndianNumber(item.i_gst_sales_28_taxable_amount)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("igst_28_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.igst_28_taxable_amount
                  ? formatIndianNumber(item.igst_28_taxable_amount)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("cess_12_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.cess_12_taxable_amount
                  ? formatIndianNumber(item.cess_12_taxable_amount)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("gst_sales_returns") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.gst_sales_returns
                  ? formatIndianNumber(item.gst_sales_returns)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("gst_sales_nill_rate_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.gst_sales_nill_rate_taxable_amount
                  ? formatIndianNumber(item.gst_sales_nill_rate_taxable_amount)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("i_gst_sales_nill_rate_taxable_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.i_gst_sales_nill_rate_taxable_amount
                  ? formatIndianNumber(
                      item.i_gst_sales_nill_rate_taxable_amount
                    )
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps.valueGetter("filter_columns")?.includes("vatav") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.vatav ? formatIndianNumber(item.vatav) : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("fright_inward") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.fright_inward
                  ? formatIndianNumber(item.fright_inward)
                  : "0.00"
              }</td>`);
          }
          {
            formRenderProps.valueGetter("filter_columns")?.includes("dalali") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.dalali ? formatIndianNumber(item.dalali) : "0.00"
              }</td>`);
          }
          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("kharajat") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.kharajat ? formatIndianNumber(item.kharajat) : "0.00"
              }</td>`);
          }

          {
            formRenderProps
              .valueGetter("filter_columns")
              ?.includes("total_amount") &&
              index === 0 &&
              (content += `<td rowspan="${
                group.length
              }" style="text-align:end;">${
                item.total_amount
                  ? formatIndianNumber(item.total_amount)
                  : "0.00"
              }</td>`);
          }

          content += "</tr>";
        })
      );
      // TOTAL ROW
      if (data && data?.length > 0) {
        content += '<tr style="background:whitesmoke; font-weight:600;">';

        content += `<td>Total</td>`;
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("credit_note_date") &&
            (content += `<td  class="text-start"></td>`);
        }
        {
          formRenderProps.valueGetter("filter_columns")?.includes("bill_no") &&
            (content += `<td style="text-align:center;"></td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("bill_date") &&
            (content += `<td style="text-align:center;"></td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("account_name") &&
            (content += `<td style="text-align:center;"></td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("product_name") &&
            (content += `<td  style="text-align:center;"></td>`);
        }
        {
          formRenderProps.valueGetter("filter_columns")?.includes("quantity") &&
            (content += `<td style="text-align:end;">${formatIndianNumberForQty(
              totalQty
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("free_quantity") &&
            (content += `<td style="text-align:end;">${formatIndianNumberForQty(
              totalFreeQty
            )}</td>`);
        }

        {
          formRenderProps.valueGetter("filter_columns")?.includes("rate") &&
            (content += `<td style="text-align:end;"></td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("unit_name") && (content += `<td></td>`);
        }

        {
          formRenderProps.valueGetter("filter_columns")?.includes("discount") &&
            (content += `<td style="text-align:end;"></td>`);
        }

        {
          formRenderProps.valueGetter("filter_columns")?.includes("cgst_per") &&
            (content += `<td style="text-align:end;"></td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("cgst_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalCGSTAmount
            )}</td>`);
        }
        {
          formRenderProps.valueGetter("filter_columns")?.includes("sgst_per") &&
            (content += `<td style="text-align:end;"></td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("sgst_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalSGSTAmount
            )}</td>`);
        }
        {
          formRenderProps.valueGetter("filter_columns")?.includes("igst_per") &&
            (content += `<td style="text-align:end;"></td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("igst_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalIGSTAmount
            )}</td>`);
        }

        // {
        //   formRenderProps.valueGetter("filter_columns")?.includes("cgst") &&
        //     (content += `<td style="text-align:end;">${formatIndianNumber(
        //       GrandtotalCGSTAmount
        //     )}</td>`);
        // }
        // {
        //   formRenderProps.valueGetter("filter_columns")?.includes("sgst") &&
        //     (content += `<td style="text-align:end;">${formatIndianNumber(
        //       GrandtotalSGSTAmount
        //     )}</td>`);
        // }
        // {
        //   formRenderProps.valueGetter("filter_columns")?.includes("igst") &&
        //     (content += `<td style="text-align:end;">${formatIndianNumber(
        //       GrandtotalIGSTAmount
        //     )}</td>`);
        // }
        // {
        //   formRenderProps.valueGetter("filter_columns")?.includes("gst") &&
        //     (content += `<td style="text-align:end;">${formatIndianNumber(
        //       GrandtotalGSTAmount
        //     )}</td>`);
        // }

        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("online_sales") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandOnlineSalesAmount
            )}</td>`);
        }

        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("gst_sales_5_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSalesGST5Amount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("cgst_2_5_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandCGST2_5Amount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("sgst_2_5_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSGST2_5Amount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("i_gst_sales_5_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSalesIGST5Amount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("igst_5_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandIGST5Amount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("gst_sales_12_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSalesGST12Amount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("cgst_6_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandCGST6Amount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("sgst_6_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSGST6Amount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("i_gst_sales_12_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSalesIGST12Amount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("igst_12_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandIGST12Amount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("gst_sales_18_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSalesGST18Amount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("cgst_9_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandCGST9Amount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("sgst_9_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSGST9Amount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("i_gst_sales_18_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSalesIGST18Amount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("igst_18_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandIGST18Amount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("gst_sales_28_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSalesGST28Amount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("cgst_14_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandCGST14Amount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("sgst_14_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSGST14Amount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("i_gst_sales_28_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandSalesIGST28Amount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("igst_28_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandIGST28Amount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("cess_12_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandCESS12Amount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("gst_sales_returns") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandGSTSalesReturnAmount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("gst_sales_nill_rate_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandGSTSalesTaxableAmount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("i_gst_sales_nill_rate_taxable_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandIGSTSalesTaxableAmount
            )}</td>`);
        }
        {
          formRenderProps.valueGetter("filter_columns")?.includes("vatav") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandVatavAmount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("fright_inward") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandFrightAmount
            )}</td>`);
        }
        {
          formRenderProps.valueGetter("filter_columns")?.includes("dalali") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandDalaliAmount
            )}</td>`);
        }
        {
          formRenderProps.valueGetter("filter_columns")?.includes("kharajat") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              totalGrandKharajatAmount
            )}</td>`);
        }
        {
          formRenderProps
            .valueGetter("filter_columns")
            ?.includes("total_amount") &&
            (content += `<td style="text-align:end;">${formatIndianNumber(
              GrandTotalAmount
            )}</td>`);
        }

        content += "</tr>";
      }

      content += "</tbody>";
      content += "</table>";

      content += "</div>";
    }

    let printWindow = window.open("", "_blank");
    if (!printWindow) {
      console.error("Failed to open print preview window.");
      return;
    }
    printWindow.document.write(`
        <html>
        <head>
          <title>Print Preview</title>
          <style>
            @page { margin: 1cm; }
            .print-page { page-break-after: always; }
            .table-bordered { width: 100%; border-collapse: collapse; }
            .table-bordered th, .table-bordered td { border: 1px solid black; padding: 8px; }
            body { font-family: Arial, sans-serif; }
          </style>
        </head>
        <body>
          ${content}
          <script>
            window.onload = function() {
              window.print();
            };
          </script>
        </body>
        </html>
      `);
    printWindow.document.close();

    if (printbuttons) printbuttons.style.display = "block";
    if (report_container) report_container.style.padding = "20px 10px";
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {CreditNoteRegisterList && CreditNoteRegisterList.length ? (
        <Form
          initialValues={initialValues}
          render={(formRenderProps: FormRenderProps) => {
            const isMatchFound = GrandTotalArray?.some((subItem: any) =>
              formRenderProps.valueGetter("filter_columns")?.includes(subItem)
            );

            return (
              <FormElement
                style={{ width: "100%", minHeight: "calc(100vh - 290px)" }}
              >
                <GridLayout
                  gap={{ rows: 10, cols: 10 }}
                  cols={[{ width: "100%" }]}
                >
                  <GridLayoutItem className="d-flex justify-content-between align-items-center">
                    <Typography.h4 className="m-0">
                      Sales Return Register List{" "}
                      {(CreditNoteRegisterDetails?.from_date ||
                        CreditNoteRegisterDetails?.to_date) && (
                        <span style={{ fontSize: 13 }}>
                          {"("}
                          {CreditNoteRegisterDetails?.from_date
                            ? moment(
                                CreditNoteRegisterDetails?.from_date,
                                "YYYY-MM-DD"
                              ).format("DD/MM/YYYY")
                            : ""}
                          {CreditNoteRegisterDetails?.from_date &&
                            CreditNoteRegisterDetails?.to_date &&
                            " - "}
                          {CreditNoteRegisterDetails?.to_date
                            ? moment(
                                CreditNoteRegisterDetails?.to_date,
                                "YYYY-MM-DD"
                              ).format("DD/MM/YYYY")
                            : ""}
                          {")"}
                        </span>
                      )}
                    </Typography.h4>
                    <div className="position-relative d-flex">
                      {/* {isPrintAccess && ( */}
                      <Button
                        style={{ marginRight: 5 }}
                        type="button"
                        fillMode={"solid"}
                        themeColor={"primary"}
                        onClick={() =>
                          printTable(groupedArray, formRenderProps)
                        }
                      >
                        Print
                      </Button>
                      {/* )} */}
                      {/* {isExcelAccess && ( */}
                      <Button
                        type="button"
                        fillMode={"solid"}
                        themeColor={"primary"}
                        onClick={handleExportExcel}
                        style={{ marginRight: 5 }}
                      >
                        Excel Export
                      </Button>
                      {/* )} */}
                      <Tooltip
                        anchorElement="target"
                        position="left"
                        parentTitle={true}
                      >
                        <Button
                          title="Filter Columns"
                          type="button"
                          themeColor={"primary"}
                          fillMode={"solid"}
                          onClick={() => setShowFilterColumns(true)}
                        >
                          Filter
                          <BsThreeDotsVertical />
                        </Button>
                      </Tooltip>
                      {showfilterColumns && (
                        <div
                          style={{
                            position: "absolute",
                            top: "32px",
                            right: "0",
                            background: "white",
                            padding: "12px",
                            border: "1px solid whitesmoke",
                            width: "250px",
                            zIndex: 2,
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-baseline">
                            <p className="m-0 fw-600">Filter</p>
                            <Button
                              themeColor={"primary"}
                              fillMode={"flat"}
                              onClick={() => setShowFilterColumns(false)}
                            >
                              <RxCross2 />
                            </Button>
                          </div>
                          <hr className="m-1" style={{ color: "lightgray" }} />
                          <Field
                            wrapperClassName="d-flex flex-column checkBoxGroup-vertical"
                            inputClassName="checkBoxGroup-vertical-input"
                            id={"filter_columns"}
                            name={"filter_columns"}
                            marginRight={0}
                            marginBeetween={8}
                            component={FormCheckboxGroup}
                            options={columns}
                          />
                        </div>
                      )}
                    </div>
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{
                      maxHeight: "calc(100vh - 334px)",
                      overflow: "scroll",
                      scrollbarWidth: "thin",
                    }}
                  >
                    <table
                      cellSpacing={1}
                      cellPadding={2}
                      className="table table-bordered w-100  currentstock-print-table"
                      style={{
                        marginTop: 1,
                      }}
                    >
                      <tr
                        className="text-center fw-600"
                        style={{
                          fontSize: 12,
                          position: "sticky",
                          top: 0,
                          outline: "1px solid #3b3b3b",
                          zIndex: 1,
                        }}
                      >
                        {/* {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("credit_note_no_string") && ( */}
                        <th style={{ minWidth: 120 }}>Sales Return No.</th>
                        {/* )} */}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("credit_note_date") && (
                          <th style={{ minWidth: 120 }}>Sales Return Date</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("bill_no") && (
                          <th style={{ minWidth: 80 }}>Bill No.</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("bill_date") && (
                          <th style={{ minWidth: 120 }}>Bill Date</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("account_name") && (
                          <th style={{ minWidth: 250 }}>Vendor Name</th>
                        )}

                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("product_name") && (
                          <th style={{ minWidth: 250 }}>Item Name</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("quantity") && (
                          <th style={{ minWidth: 150 }}>Qty</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("free_quantity") && (
                          <th style={{ minWidth: 150 }}>Free Qty</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("rate") && (
                          <th style={{ minWidth: 150 }}>Rate</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("unit_name") && (
                          <th style={{ minWidth: 120 }}>Unit</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("discount") && (
                          <th style={{ minWidth: 80 }}>Discount</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("cgst_per") && (
                          <th style={{ minWidth: 100 }}>CGST(%)</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("cgst_amount") && (
                          <th style={{ minWidth: 150 }}>CGST Amount</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("sgst_per") && (
                          <th style={{ minWidth: 100 }}>SGST(%)</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("sgst_amount") && (
                          <th style={{ minWidth: 150 }}>SGST Amount</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("igst_per") && (
                          <th style={{ minWidth: 100 }}>IGST(%)</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("igst_amount") && (
                          <th style={{ minWidth: 150 }}>IGST Amount</th>
                        )}
                        {/* {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("cgst") && (
                          <th style={{ minWidth: 150 }}>Total CGST Amount</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("sgst") && (
                          <th style={{ minWidth: 150 }}>Total SGST Amount</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("igst") && (
                          <th style={{ minWidth: 150 }}>Total IGST Amount</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("gst") && (
                          <th style={{ minWidth: 150 }}>Total GST Amount</th>
                        )} */}

                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("online_sales") && (
                          <th style={{ minWidth: 150 }}>Online Sales</th>
                        )}

                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("gst_sales_5_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>Sales GST 5%</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("cgst_2_5_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>CGST 2.5%</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("sgst_2_5_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>SGST 2.5%</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("i_gst_sales_5_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>Sales IGST 5%</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("igst_5_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>IGST 5%</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("gst_sales_12_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>Sales GST 12%</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("cgst_6_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>CGST 6%</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("sgst_6_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>SGST 6%</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("i_gst_sales_12_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>Sales IGST 12%</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("igst_12_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>IGST 12%</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("gst_sales_18_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>Sales GST 18%</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("cgst_9_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>CGST 9%</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("sgst_9_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>SGST 9%</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("i_gst_sales_18_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>Sales IGST 18%</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("igst_18_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>IGST 18%</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("gst_sales_28_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>Sales GST 28%</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("cgst_14_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>CGST 14%</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("sgst_14_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>SGST 14%</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("i_gst_sales_28_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>Sales IGST 28%</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("igst_28_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>IGST 28%</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("cess_12_taxable_amount") && (
                          <th style={{ minWidth: 150 }}>CESS 12%</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("gst_sales_returns") && (
                          <th style={{ minWidth: 150 }}>GST Sales Retrun</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("gst_sales_nill_rate_taxable_amount") && (
                          <th style={{ minWidth: 200 }}>
                            GST Sales Nill Rate Amount
                          </th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes(
                            "i_gst_sales_nill_rate_taxable_amount"
                          ) && (
                          <th style={{ minWidth: 200 }}>
                            IGST Sales Nill Rate Amount
                          </th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("vatav") && (
                          <th style={{ minWidth: 150 }}>Vatav</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("fright_inward") && (
                          <th style={{ minWidth: 150 }}>Fright</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("dalali") && (
                          <th style={{ minWidth: 150 }}>Dalali</th>
                        )}
                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("kharajat") && (
                          <th style={{ minWidth: 150 }}>Kharajat</th>
                        )}

                        {formRenderProps
                          .valueGetter("filter_columns")
                          ?.includes("total_amount") && (
                          <th style={{ minWidth: 150 }}>Total Amount</th>
                        )}
                      </tr>
                      {groupedArray &&
                        groupedArray?.length > 0 &&
                        groupedArray?.map((group: any) =>
                          group.map((item: any, index: number) => {
                            const groupKey = `${item?.credit_note_guid}`;
                            const isSelected = selectedGroup === groupKey;
                            return (
                              <tr
                                className="text-center"
                                style={{
                                  background: isSelected
                                    ? "rgb(255 198 198 / 53%)"
                                    : "transparent",
                                }}
                                onClick={() =>
                                  handleRowClick(item.credit_note_guid)
                                }
                              >
                                {index === 0 && (
                                  <td
                                    rowSpan={group.length}
                                    className="text-start register-edit-column"
                                  >
                                    {item.credit_note_no_string}
                                    {isEditAccess && (
                                      <IconButton
                                        type="button"
                                        fillMode="flat"
                                        themeColor={"primary"}
                                        size="small"
                                        ref={isEditBtnRef}
                                        style={{
                                          padding: "15px",
                                          marginLeft: "5px",
                                        }}
                                        onClick={() => {
                                          isEditBtnRef.current = true;
                                          navigate("/creditnote/edit", {
                                            state: {
                                              credit_note_guid:
                                                item?.credit_note_guid,
                                            },
                                          });
                                        }}
                                      >
                                        <FiEdit
                                          className="absolute-position"
                                          style={{
                                            fontSize: "20px",
                                            zIndex: 0,
                                            color: "red",
                                          }}
                                        />
                                      </IconButton>
                                    )}
                                  </td>
                                )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("credit_note_date") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-start"
                                    >
                                      {item.credit_note_date}
                                    </td>
                                  )}

                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("bill_no") &&
                                  index === 0 && (
                                    <td rowSpan={group.length}>
                                      {item.bill_no}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("bill_date") &&
                                  index === 0 && (
                                    <td rowSpan={group.length}>
                                      {item.bill_date
                                        ? moment(
                                            item.bill_date,
                                            "DD/MM/YYYY"
                                          )?.format("DD MMM YYYY")
                                        : ""}
                                    </td>
                                  )}

                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("inward_date") &&
                                  index === 0 && (
                                    <td rowSpan={group.length}>
                                      {item.inward_date
                                        ? moment(
                                            item.inward_date,
                                            "DD/MM/YYYY"
                                          )?.format("DD MMM YYYY")
                                        : ""}
                                    </td>
                                  )}

                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("account_name") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-start"
                                    >
                                      {item.account_name}
                                    </td>
                                  )}

                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("product_name") && (
                                  <td className="text-start">
                                    {item?.product_name}
                                  </td>
                                )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("quantity") && (
                                  <td className="text-end">
                                    {formatIndianNumberForQty(item?.quantity) ||
                                      0}
                                  </td>
                                )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("free_quantity") && (
                                  <td className="text-end">
                                    {formatIndianNumberForQty(
                                      item?.free_quantity
                                    ) || 0}
                                  </td>
                                )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("rate") && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.rate || 0)}
                                  </td>
                                )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("unit_name") && (
                                  <td>{item?.unit_name}</td>
                                )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("discount") && (
                                  <td className="text-end">
                                    {item?.discount ? item?.discount : ""}
                                    {item.discount &&
                                      item.discount_type &&
                                      (item?.discount_type === 1
                                        ? " ₹"
                                        : item?.discount_type === 2
                                        ? " %"
                                        : "")}
                                  </td>
                                )}

                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("cgst_per") && (
                                  <td className="text-end">
                                    {item?.cgst_per
                                      ? `${item?.cgst_per} %`
                                      : ""}
                                  </td>
                                )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("cgst_amount") && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.cgst_amount || 0)}
                                  </td>
                                )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("sgst_per") && (
                                  <td className="text-end">
                                    {item?.sgst_per
                                      ? `${item?.sgst_per} %`
                                      : ""}
                                  </td>
                                )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("sgst_amount") && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.sgst_amount || 0)}
                                  </td>
                                )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("igst_per") && (
                                  <td className="text-end">
                                    {item?.igst_per
                                      ? `${item?.igst_per} %`
                                      : ""}
                                  </td>
                                )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("igst_amount") && (
                                  <td className="text-end">
                                    {formatIndianNumber(item?.igst_amount || 0)}
                                  </td>
                                )}
                                {/* {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("cgst") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(item?.cgst || 0)}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("sgst") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(item?.sgst || 0)}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("igst") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(item?.igst || 0)}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("gst") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(item?.gst || 0)}
                                    </td>
                                  )} */}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("online_sales") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.online_sales || 0
                                      )}
                                    </td>
                                  )}

                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("gst_sales_5_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.gst_sales_5_taxable_amount || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("cgst_2_5_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.cgst_2_5_taxable_amount || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("sgst_2_5_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.sgst_2_5_taxable_amount || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("i_gst_sales_5_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.i_gst_sales_5_taxable_amount || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("igst_5_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.igst_5_taxable_amount || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("gst_sales_12_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.gst_sales_12_taxable_amount || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("cgst_6_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.cgst_6_taxable_amount || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("sgst_6_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.sgst_6_taxable_amount || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("i_gst_sales_12_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.i_gst_sales_12_taxable_amount || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("igst_12_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.igst_12_taxable_amount || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("gst_sales_18_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.gst_sales_18_taxable_amount || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("cgst_9_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.cgst_9_taxable_amount || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("sgst_9_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.sgst_9_taxable_amount || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("i_gst_sales_18_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.i_gst_sales_18_taxable_amount || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("igst_18_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.igst_18_taxable_amount || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("gst_sales_28_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.gst_sales_28_taxable_amount || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("cgst_14_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.cgst_14_taxable_amount || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("sgst_14_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.sgst_14_taxable_amount || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("i_gst_sales_28_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.i_gst_sales_28_taxable_amount || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("igst_28_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.igst_28_taxable_amount || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("cess_12_taxable_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.cess_12_taxable_amount || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("gst_sales_returns") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.gst_sales_returns || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes(
                                    "gst_sales_nill_rate_taxable_amount"
                                  ) &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.gst_sales_nill_rate_taxable_amount ||
                                          0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes(
                                    "i_gst_sales_nill_rate_taxable_amount"
                                  ) &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.i_gst_sales_nill_rate_taxable_amount ||
                                          0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("vatav") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(item?.vatav || 0)}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("fright_inward") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.fright_inward || 0
                                      )}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("dalali") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(item?.dalali || 0)}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("kharajat") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(item?.kharajat || 0)}
                                    </td>
                                  )}
                                {formRenderProps
                                  .valueGetter("filter_columns")
                                  ?.includes("total_amount") &&
                                  index === 0 && (
                                    <td
                                      rowSpan={group.length}
                                      className="text-end"
                                    >
                                      {formatIndianNumber(
                                        item?.total_amount || 0
                                      )}
                                    </td>
                                  )}
                              </tr>
                            );
                          })
                        )}
                      {groupedArray &&
                        groupedArray?.length > 0 &&
                        isMatchFound && (
                          <tr
                            className="text-center"
                            style={{
                              background: "whitesmoke",
                              fontWeight: 600,
                            }}
                          >
                            <td className="text-start">Total</td>
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("invoice_no") && (
                              <td className="text-start"></td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("credit_note_date") && <td></td>}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("bill_no") && <td></td>}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("bill_date") && <td></td>}

                            {/* {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("inward_date") && (
                              <td className="text-start"></td>
                            )} */}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("account_name") && (
                              <td className="text-start"></td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("product_name") && (
                              <td className="text-start"></td>
                            )}

                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("quantity") && (
                              <td className="text-end">
                                {formatIndianNumberForQty(totalQty) || 0}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("free_quantity") && (
                              <td className="text-end">
                                {formatIndianNumberForQty(totalFreeQty) || 0}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("rate") && (
                              <td className="text-end"></td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("unit_name") && <td></td>}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("discount") && <td></td>}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("cgst_per") && (
                              <td className="text-end"></td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("cgst_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalCGSTAmount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("sgst_per") && (
                              <td className="text-end"></td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("sgst_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalSGSTAmount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("igst_per") && (
                              <td className="text-end"></td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("igst_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalIGSTAmount)}
                              </td>
                            )}
                            {/* {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("cgst") && (
                              <td className="text-end">
                                {formatIndianNumber(GrandtotalCGSTAmount)}
                              </td>
                            )}

                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("sgst") && (
                              <td className="text-end">
                                {formatIndianNumber(GrandtotalSGSTAmount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("igst") && (
                              <td className="text-end">
                                {formatIndianNumber(GrandtotalIGSTAmount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("gst") && (
                              <td className="text-end">
                                {formatIndianNumber(GrandtotalGSTAmount)}
                              </td>
                            )} */}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("online_sales") && (
                              <td className="text-end">
                                {formatIndianNumber(
                                  totalGrandOnlineSalesAmount
                                )}
                              </td>
                            )}
                          
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("gst_sales_5_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandSalesGST5Amount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("cgst_2_5_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandCGST2_5Amount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("sgst_2_5_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandSGST2_5Amount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("i_gst_sales_5_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandSalesIGST5Amount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("igst_5_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandIGST5Amount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("gst_sales_12_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandSalesGST12Amount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("cgst_6_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandCGST6Amount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("sgst_6_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandSGST6Amount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("i_gst_sales_12_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(
                                  totalGrandSalesIGST12Amount
                                )}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("igst_12_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandIGST12Amount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("gst_sales_18_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandSalesGST18Amount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("cgst_9_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandCGST9Amount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("sgst_9_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandSGST9Amount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("i_gst_sales_18_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(
                                  totalGrandSalesIGST18Amount
                                )}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("igst_18_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandIGST18Amount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("gst_sales_28_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandSalesGST28Amount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("cgst_14_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandCGST14Amount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("sgst_14_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandSGST14Amount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("i_gst_sales_28_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(
                                  totalGrandSalesIGST28Amount
                                )}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("igst_28_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandIGST28Amount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("cess_12_taxable_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandCESS12Amount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("gst_sales_returns") && (
                              <td className="text-end">
                                {formatIndianNumber(
                                  totalGrandGSTSalesReturnAmount
                                )}
                              </td>
                            )}

                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes(
                                "gst_sales_nill_rate_taxable_amount"
                              ) && (
                              <td className="text-end">
                                {formatIndianNumber(
                                  totalGrandGSTSalesTaxableAmount
                                )}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes(
                                "i_gst_sales_nill_rate_taxable_amount"
                              ) && (
                              <td className="text-end">
                                {formatIndianNumber(
                                  totalGrandIGSTSalesTaxableAmount
                                )}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("vatav") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandVatavAmount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("fright_inward") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandFrightAmount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("dalali") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandDalaliAmount)}
                              </td>
                            )}
                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("kharajat") && (
                              <td className="text-end">
                                {formatIndianNumber(totalGrandKharajatAmount)}
                              </td>
                            )}

                            {formRenderProps
                              .valueGetter("filter_columns")
                              ?.includes("total_amount") && (
                              <td className="text-end">
                                {formatIndianNumber(GrandTotalAmount)}
                              </td>
                            )}
                          </tr>
                        )}
                    </table>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            );
          }}
        />
      ) : (
        <AlertBox />
      )}
    </>
  );
};
export default CreditNoteRegisterReportForm;
